class StPrefixesController {
    constructor(locationsService, $filter, $translate) {
        'ngInject';
        this.name = 'stPrefixes';
        this.locationsService = locationsService;
        this.$filter = $filter;
        this.prefixes = [];
        this.selectedPrefix = {};
        this.translations = $translate.instant([
            'mobile_phone'
        ]);
    }

    $onInit() {
        this.getPrefixes();
    }

    changePrefix() {
        this.data.mobile_country_id = this.selectedPrefix.id;
        this.removePrefix();
    }

    removePrefix() {
        //TODO: Make name independent by type phone for example, to work for all fields
        // Transformation si made on save on amend controller
        this.data.mobile_phone = this.$filter('removePrefix')(this.data.mobile_phone, this.selectedPrefix.phonePrefix);
        this.data.mobile_phone_prefix = this.selectedPrefix.phonePrefix;
    }

    getPrefixes() {
        this.locationsService.getCountries()
            .then((response) => {
                this.prefixes = response.reduce((items, item) => {
                    items[item.id] = item;
                    return items;
                }, {});

                let prefix = this.prefixes[this.data.mobile_country_id] || false;
                if (prefix) {
                    this.selectedPrefix = prefix;
                    this.removePrefix();
                }
            });
    }

}

export default StPrefixesController;


// WEBPACK FOOTER //
// ./client/app/common/stPrefixes/stPrefixes.controller.js